import { useState, useEffect, useMemo, useRef } from 'react'
import axios from 'axios'

import { usePrevious } from './useUserEmailTemplates'
import { useAdminURL } from '../contexts/Domain'
import { IDimensionDropdownListProps } from '../components/organizationalElements/OdsTypes'

export default function useDimensionDropdownData(props: IDimensionDropdownListProps) {
    const adminURL = useAdminURL();
    const cancelRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    let { current: cancelUpdates } = cancelRef;
    const {url, keywords, page, onNewResults, onNextPageResults} = props;

    const fetchNewResults = async (hasPageChanged?: boolean) => {
        setLoading(true);
        setError('');

        try {
            const response = await axios.get(`${adminURL}${url}?&keywords=${keywords || ''}&pageSize=10&pageNumber=${page}`);
            
            if (cancelUpdates) return;
    
            if (response.status === 200) {
                setLoading(false);
                if (hasPageChanged) {
                    if (typeof onNextPageResults === 'function') {
                        onNextPageResults(response.data);
                    }
                } else {
                    if (typeof onNewResults === 'function') {
                        onNewResults(response.data);
                    }
                }
            } else {
                setError('An error occurred while retrieving results');
            }
        } catch (error) {
            if (cancelUpdates) return;
            setLoading(false);
            setError('An error occurred while retrieving results');
        }
    }

    const prevPage = usePrevious(page);

    useEffect(() => {
        cancelUpdates = false;
        const hasPageChanged = page !== prevPage;

        fetchNewResults(hasPageChanged);

        return () => {
            cancelUpdates = true;
        }
    }, [page, keywords]);

    return useMemo(() => ({
        loading,
        error,
    }), [
        loading,
        error,
    ]);
}
